import { IUser } from '@collections/users/interfaces/user.interface';
import { Mutation, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';

export interface RemoveProductResponse {
  removeProduct: IUser;
}

@Injectable({providedIn: 'root'})
export class removeProductGQL extends Mutation<RemoveProductResponse> {
  document = gql`
  mutation removeProduct ($productId: ObjectId!, $lang: String!){
    removeProduct(lang: $lang, productId: $productId){
      _id
      profile {
        _id
        lang
        savedProducts (lang: $lang) {
          _id
        }
      }
    }
  }
  `;
}
